<template>
  <div class="t-switch" :class="{'is-check': value}" @click="onEmit">
    <span></span>
  </div>
</template>
<script>
  /**
   * @param value [Boolean] v-model绑定的值
   * @param change [Function] 点击变更触发事件
   *
   * @example
   *
    <t-switch v-model="isAutoLogin" @change="setAutoLogin()"></t-switch>
   */
  export default{
    name: 'tSwitch',
    props: {
      value: {},
    },
    data() {
      return {};
    },
    methods: {
      onEmit() {
        this.$emit('input', !this.value);
        this.$emit('change', !this.value);
      },
    },
  };
</script>
<style lang="scss">
  .t-switch {
    font-size: 0;
    width: 0.48rem;
    border-radius: 0.24rem;
    padding: 0.01rem;
    background: #d9d9d9;
    text-align: left;
    height: 0.3rem;
    display: inline-block;
    &.is-check {
      background-color: #FC6A00;
      span { margin-left: 0.18rem; }
    }
  }
  .t-switch span {
    display: inline-block;
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .4);
    background-color: #fff;
    transition: all 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch.vue